/* =========================================================
 * bootstrap-modal.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#modals
 * =========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */

// NOTE: This is a modified version of the original Bootstrap modal.js file.
// The modifications are necessary to make Bootstrap modals work with the popover API
// which is used to implement modals in Aha! instead of the standard Bootstrap approach
// of appending the modal to the end of the body and using a backdrop div.
// The popover API provides better stacking context handling and avoids issues with z-index
// and overflow that can occur with nested modals or modals inside containers with overflow:hidden.

!function ($) {
  "use strict";

  /* MODAL CLASS DEFINITION
   * ====================== */

  const Modal = function (element, options) {
    this.options = options;
    this.$element = $(element)
      .delegate('[data-dismiss="modal"]', 'click.dismiss.modal', $.proxy(this.hide, this));
    this.options.remote && this.$element.find('.modal-body').load(this.options.remote);

    element.setAttribute('popover', 'manual');

    // Because popover API ::backdrop pseudo-element does not block interaction with the rest of the page,
    // we need to manually handle clicks outside the modal to close it when backdrop is enabled.
    // To do this, we have added a ::before pseudo-element to the modal that covers the entire viewport and is transparent.
    // Because ::before size is not included in bounding box calculations, we can check if a click is outside the modal bounds.
    // This allows us to detect clicks outside the modal content and close the modal if needed.
    this.$element.on('click', e => {
      if (this.options.backdrop === 'static') return;

      // See if the click is outside the dialog. Works around the fact that the popover API's backdrop cannot intercept clicks.
      const {top, bottom, left, right} = this.$element[0].getBoundingClientRect();
      if (e.clientX < left || e.clientX > right || e.clientY < top || e.clientY > bottom) {
        this.hide();
      }
    });
  };

  Modal.prototype = {
    constructor: Modal,

    toggle: function () {
      return this[!this.isShown ? 'show' : 'hide']();
    },

    show: function () {
      const that = this;
      const e = $.Event('show');

      this.$element.trigger(e);

      if (this.isShown || e.isDefaultPrevented()) return;

      this.isShown = true;

      this.escape();

      this.backdrop(function () {
        const transition = $.support.transition && that.$element.hasClass('fade');

        if (!that.$element.parent().length) {
          that.$element.appendTo(document.body); // don't move modals dom position
        }

        that.$element.show();
        that.$element[0].showPopover();

        if (transition) {
          that.$element[0].offsetWidth; // force reflow
        }

        that.$element
          .addClass('in')
          .attr('aria-hidden', false);

        that.enforceFocus();

        transition ?
          that.$element.one($.support.transition.end, function () { that.$element.focus().trigger('shown'); }) :
          that.$element.focus().trigger('shown');
      });
    },

    hide: function (e) {
      e && e.preventDefault();

      const that = this;

      e = $.Event('hide');

      this.$element.trigger(e);

      if (!this.isShown || e.isDefaultPrevented()) return;

      this.isShown = false;

      this.escape();

      $(document).off('focusin.modal');

      this.$element
        .removeClass('in')
        .attr('aria-hidden', true);

      $.support.transition && this.$element.hasClass('fade') ?
        this.hideWithTransition() :
        this.hideModal();
    },

    enforceFocus: function () {
      const that = this;
      $(document).on('focusin.modal', function (e) {
        if (that.$element[0] !== e.target && !that.$element.has(e.target).length) {
          that.$element.focus();
        }
      });
    },

    escape: function () {
      const that = this;
      if (this.isShown && this.options.keyboard) {
        this.$element.on('keyup.dismiss.modal', function (e) {
          e.which === 27 && that.hide();
        });
      } else if (!this.isShown) {
        this.$element.off('keyup.dismiss.modal');
      }
    },

    hideWithTransition: function () {
      const that = this;
      const timeout = setTimeout(function () {
        that.$element.off($.support.transition.end);
        that.hideModal();
      }, 500);

      this.$element.one($.support.transition.end, function () {
        clearTimeout(timeout);
        that.hideModal();
      });
    },

    hideModal: function () {
      const that = this;
      this.$element.hide();
      this.$element[0].hidePopover();
      this.backdrop(function () {
        that.removeBackdrop();
        that.$element.trigger('hidden');
      });
    },

    removeBackdrop: function () {
      this.$backdrop && this.$backdrop.remove();
      this.$backdrop = null;
    },

    backdrop: function (callback) {
      if (callback) callback();
    }
  };


  /* MODAL PLUGIN DEFINITION
   * ======================= */

  const old = $.fn.modal;

  $.fn.modal = function (option) {
    return this.each(function () {
      const $this = $(this);
      let data = $this.data('modal');
      const options = $.extend({}, $.fn.modal.defaults, $this.data(), typeof option === 'object' && option);
      if (!data) $this.data('modal', (data = new Modal(this, options)));
      if (typeof option === 'string') data[option]();
      else if (options.show) data.show();
    });
  };

  $.fn.modal.defaults = {
    backdrop: true,
    keyboard: true,
    show: true
  };

  $.fn.modal.Constructor = Modal;


  /* MODAL NO CONFLICT
   * ================= */

  $.fn.modal.noConflict = function () {
    $.fn.modal = old;
    return this;
  };


  /* MODAL DATA-API
   * ============== */

  $(document).on('click.modal.data-api', '[data-toggle="modal"]', function (e) {
    const $this = $(this);
    const href = $this.attr('href');
    const $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))); // strip for ie7
    const option = $target.data('modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

    e.preventDefault();

    $target
      .modal(option)
      .one('hide', function () {
        $this.focus();
      });
  });

}(window.jQuery);
